import Api from '@/services/Api'

export default {
  getAll () {
    return Api().get('/config/notifications')
  },
  seen (NotificationId) {
    return Api().put('/config/notifications/'+ NotificationId +'/seen',)
  },
}
